import { render } from "./ModalPix.vue?vue&type=template&id=0c5054fc&scoped=true"
import script from "./ModalPix.vue?vue&type=script&lang=js"
export * from "./ModalPix.vue?vue&type=script&lang=js"

import "./ModalPix.vue?vue&type=style&index=0&id=0c5054fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5054fc"]])

export default __exports__